
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";
import FormGroup from "@/components/form/FormGroupNew.vue";
import FormInputGroup from "@/components/form/FormInputGroupNew.vue";
import FormMultiselect from "@/components/form/FormSelectNew.vue";
import FormSelect from "@/components/form/FormSelectNew.vue";
import UIButton from "@/components/button/ui-button.vue";
import PlusIcon from "@/components/icons/PlusIconNew.vue";
import HoveredIcon from "@/components/icons/HoveredIcon.vue";
import _ from "lodash";

@Component({
  components: {
    ValidationProvider,
    FormGroup,
    PlusIcon,
    HoveredIcon,
    FormInputGroup,
    FormMultiselect,
    FormSelect,
    UIButton,
  },
})
export default class HealthInformation extends Vue {
  @Prop({ required: true }) readonly formData!: Record<string, any>;
  localFormData: Record<string, any> = {};

  allergyOptions = {
    food: [
      { label: "Dairy", value: "Dairy" },
      { label: "Nuts", value: "Nuts" },
      { label: "Shellfish", value: "Shellfish" },
    ],
    medication: [
      { label: "Penicillin", value: "Penicillin" },
      { label: "Sulfa", value: "Sulfa" },
      { label: "NSAIDs", value: "NSAIDs" },
    ],
    environmental: [
      { label: "Pollen", value: "Pollen" },
      { label: "Dust", value: "Dust" },
      { label: "Pet Dander", value: "Pet Dander" },
    ],
  };

  @Watch("formData", { immediate: true, deep: true })
  onFormDataChange(newVal: Record<string, any>) {
    this.localFormData = _.cloneDeep(newVal);
  }

  updateField(field: string, value: any) {
    this.localFormData[field] = value;
    this.$emit("update:formData", this.localFormData);
  }

  updateMedication(index: number, field: string, value: any) {
    const updatedMedications = [...this.formData.client_medications];
    updatedMedications[index] = {
      ...updatedMedications[index],
      [field]: value,
    };
    this.updateField("client_medications", updatedMedications);
  }

  addNewMedication() {
    const newMedication = {
      name: "",
      dosage: "",
      frequency: "",
      file: false,
    };
    const updatedMedications = [
      ...(this.formData.client_medications || []),
      newMedication,
    ];
    this.updateField("client_medications", updatedMedications);
  }

  saveMedications() {
    // Implement save logic if needed
  }
}
